module.exports = __webpack_public_path__ + "img/5.c0c71d5f.jpg";